export default __webpack_public_path__ + "static/mastering_ai_main-e47d60fe6d64820db749c65f2ec88841.svg";